import Vue from "vue";
import VueRouter from "vue-router";
// import Home from "@/views/Home.vue";
import store from "@/store";
Vue.use(VueRouter);

const originalpush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return originalpush.call(this, location).catch((err) => err);
};

const routes = [
  {
    path: "/",
    redirect: "/app",
  },
  {
    path: '/app',
    name: 'App',
    component: () => import("@/App.vue")
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach(async (to, from, next) => {

  if (document.location.origin.indexOf("mktindex.com") > 0) {
    if (localStorage.getItem('language') == 'en') {
      document.title = "Moojing CMI";
    } else {
      document.title = "魔镜CMI";
    }
    document.querySelector('link[rel="icon"]').href = '/favicon.ico'
  } else {
    document.title = "灵感中心";
    document.querySelector('link[rel="icon"]').href = 'https://oemlogin.mktindex.com/static/oem/intage-icon.png'
  }
  next();
});

export default router;
